module.exports = __webpack_public_path__ + "static/media/Kitchen.7c40a2ac.glb";